import { createSlice } from '@reduxjs/toolkit';
import { createIndependentStore, createScopedStore } from '@utils/react';
import { restoreLibraryStateFromSearchParams } from './util.restore-state-from-search-params.js';

const SEARCH_QUERY_MAX_LENGTH = 255;
const initialState = {
  libraryId: "",
  ui: {
    displayMode: "list",
    expandedItemId: undefined,
    selectedGroupIds: {}
  },
  filters: {
    searchQuery: "",
    selected: {
      accordions: {},
      checkboxes: {},
      radiobuttons: {}
    }
  }
};
function makeLibraryStore(stateOverrides = initialState, location = undefined, middleware) {
  const restoredState = restoreLibraryStateFromSearchParams({
    ...initialState,
    ...stateOverrides,
    ui: {
      ...initialState.ui,
      ...stateOverrides.ui
    }
  }, location);
  const slice = createSlice({
    name: `provider/library`,
    initialState: restoredState,
    reducers: {
      setDisplayMode(state, action) {
        state.ui.displayMode = action.payload;
        state.ui.expandedItemId = undefined;
      },
      setSearchQuery(state, action) {
        state.filters.searchQuery = action.payload;
      },
      toggleExpandedItemId(state, action) {
        if (state.ui.expandedItemId === action.payload) {
          state.ui.expandedItemId = undefined;
        } else {
          state.ui.expandedItemId = action.payload;
        }
      },
      toggleSelectedGroup(state, action) {
        state.ui.expandedItemId = undefined;
        state.ui.selectedGroupIds[action.payload] = !state.ui.selectedGroupIds[action.payload];
      },
      toggleAccordionFilter(state, action) {
        state.ui.expandedItemId = undefined;
        if (action.payload.ids.length) {
          state.filters.selected.accordions[action.payload.id] = action.payload.ids;
        } else {
          // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
          delete state.filters.selected.accordions[action.payload.id];
        }
      },
      toggleCheckboxFilter(state, action) {
        state.ui.expandedItemId = undefined;
        if (action.payload.ids.length) {
          state.filters.selected.checkboxes[action.payload.id] = action.payload.ids;
        } else {
          // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
          delete state.filters.selected.checkboxes[action.payload.id];
        }
      },
      toggleRadiobuttonFilter(state, action) {
        state.ui.expandedItemId = undefined;
        state.filters.selected.radiobuttons[action.payload.id] = action.payload.value;
      },
      resetFilterOption(state, action) {
        switch (action.payload.filterType) {
          case "radiobuttons":
            if (state.filters.selected.radiobuttons[action.payload.filterId] === action.payload.id) {
              state.filters.selected.radiobuttons[action.payload.filterId] = undefined;
            }
            break;
          case "accordions":
          case "checkboxes":
            {
              const filter = state.filters.selected[action.payload.filterType][action.payload.filterId];
              if (filter) {
                state.filters.selected[action.payload.filterType][action.payload.filterId] = filter.filter(option => option !== action.payload.id);
              }
              break;
            }
        }
      },
      resetFilters(state) {
        state.ui.expandedItemId = undefined;
        state.ui.selectedGroupIds = {};
        state.filters.searchQuery = "";
        state.filters.selected = {
          accordions: {},
          checkboxes: {},
          radiobuttons: {}
        };
      }
    }
  });
  if (middleware) {
    return createIndependentStore({
      ...slice,
      middleware: getDefaultMiddleWare => getDefaultMiddleWare().prepend(middleware.middleware)
    });
  } else {
    return createIndependentStore(slice);
  }
}
const libraryStore = createScopedStore(makeLibraryStore());
const useLibrarySelector = libraryStore.useSelector;
const useLibraryDispatch = libraryStore.useDispatch;
const libraryActions = libraryStore.actions;

export { SEARCH_QUERY_MAX_LENGTH, libraryActions, libraryStore, makeLibraryStore, useLibraryDispatch, useLibrarySelector };
//# sourceMappingURL=store.js.map
